function shouldShowAIComponentForStatus(status) {
  return status === 'pending' || status === 'completedNoResult';
}
export default shouldShowAIComponentForStatus;